import { render, staticRenderFns } from "./stockList.vue?vue&type=template&id=29e161d4&scoped=true&"
import script from "./stockList.vue?vue&type=script&lang=js&"
export * from "./stockList.vue?vue&type=script&lang=js&"
import style0 from "./stockList.vue?vue&type=style&index=0&id=29e161d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e161d4",
  null
  
)

export default component.exports